import { AlgoRerunDto, Consortium, Sample } from '@cambridgeassessment/lib-ee-commons';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db/entries';
import {
  SamplesManagementActionTypes,
  SET_CENTRE_LEARNERS,
  SET_ERROR,
  SET_IS_SAMPLE_LOADING,
  SET_SAMPLE,
  SET_IS_ENTRIES_PATCHING,
  SET_IS_ENTRIES_LOADING,
  SET_CONSORTIUM_DATA,
  SET_SAMPLE_SEARCH_PARAMS,
  SampleSearchParams,
  RESET_STATE,
  RESET_STATE_FULL,
  SET_IS_SAMPLE_BEING_RERUN,
  SET_ALGO_RERUNS,
} from './types';

export const setSample = (sample: Sample): SamplesManagementActionTypes => ({
  type: SET_SAMPLE,
  payload: { sample },
});

export const resetState = (): SamplesManagementActionTypes => ({
  type: RESET_STATE,
});

export const resetStateFull = (): SamplesManagementActionTypes => ({
  type: RESET_STATE_FULL,
});

export const setConsortiumData = (consortium: Consortium): SamplesManagementActionTypes => ({
  type: SET_CONSORTIUM_DATA,
  payload: { consortium },
});

export const setAlgoReruns = (algoReruns: AlgoRerunDto[]): SamplesManagementActionTypes => ({
  type: SET_ALGO_RERUNS,
  payload: { algoReruns },
});

export const setCentreLearners = (centreLearners: Entry[]): SamplesManagementActionTypes => ({
  type: SET_CENTRE_LEARNERS,
  payload: { centreLearners },
});

export const setIsSampleBeingRerun = (value: boolean): SamplesManagementActionTypes => ({
  type: SET_IS_SAMPLE_BEING_RERUN,
  payload: { value },
});

export const setIsLoading = (value: boolean): SamplesManagementActionTypes => ({
  type: SET_IS_SAMPLE_LOADING,
  payload: { value },
});

export const setIsEntriesLoading = (value: boolean): SamplesManagementActionTypes => ({
  type: SET_IS_ENTRIES_LOADING,
  payload: { value },
});

export const setIsEntriesPatching = (value?: boolean): SamplesManagementActionTypes => ({
  type: SET_IS_ENTRIES_PATCHING,
  payload: { value },
});

export const setSampleSearchParams = (sampleSearchParams: SampleSearchParams): SamplesManagementActionTypes => ({
  type: SET_SAMPLE_SEARCH_PARAMS,
  payload: { sampleSearchParams },
});

export const setError = (): SamplesManagementActionTypes => ({
  type: SET_ERROR,
});
